import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyA_8oeJyq6a7tYUx9iW_ZTVD95ZYlbNZaQ",
    authDomain: "test-bts-46132.firebaseapp.com",
    databaseURL: "https://test-bts-46132.firebaseio.com",
    projectId: "test-bts-46132",
    storageBucket: "test-bts-46132.appspot.com",
    messagingSenderId: "637032676630"
  };
  firebase.initializeApp(config);
  firebase.firestore().settings({ timestampsInSnapshots: true });

  export default firebase;